import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { useEffect } from 'react';
import MemberDrainageBar from '@elem/compCommon/MemberDrainageBar';
import css from './index.module.scss';
import A from './A';
import B1 from './B1';
import Recommend from './Recommend';
import C from './C';
// import D from './D';
import E from './E';
import F0 from './F0';
import F from './F';
import F1 from './F1';
import G from './G';
import GG from './GG';
import G1 from './G1';
import H from './H';
import H2 from './H2';
import I from './I';
import M from './M';
import N from './N';
import O from './O';
import D2TSB from './D2TSB';
import DPTSB from './DPTSB';
import R2PTSB from './R2PTSB';
// import P from './P';
import Subscribe from './Subscribe';
import ScrollMagicFn from '@/utils/ScrollMagic';
import { useGlobal } from '@/utils/useGlobal';
import EfScrollAni from '@/efscrollani';

export default function LandingPage(): JSX.Element {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const US_SITE = ['us'].includes(locale);
    const SHOW_TS_BUNDLE_SITE = ['sa', 'za', 'au'].includes(locale);

    if (typeof window !== 'undefined') {
        if (!window.AniContainer) {
            window.AniContainer = new EfScrollAni();
        }
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
        window.aniController = new ScrollMagic.Controller();
    }

    useEffect(() => {
        return () => {
            setTimeout(() => {
                /* @ts-ignore */
                aniController.destroy();
            });
        };
    }, []);

    return (
        <div className={`landing_page ${css.landing_page}`}>
            <A />
            {locale === 'ca' && <MemberDrainageBar />}
            {/* <B /> */}
            {locale === 'ca' && <B1 />}
            <C />
            {locale !== 'ca' && <B1 />}
            {!SHOW_TS_BUNDLE_SITE && locale !== 'ca' && <Recommend />}
            <E SHOW_TS_BUNDLE_SITE={SHOW_TS_BUNDLE_SITE} />
            {SHOW_TS_BUNDLE_SITE && (
                <>
                    <R2PTSB />
                    <D2TSB />
                    {locale !== 'au' && <H />}
                    <DPTSB />
                    {/* <G1TS /> */}
                    {locale === 'au' && <G1 />}
                    {locale === 'au' && <Subscribe />}
                    {locale === 'au' && <H />}
                </>
            )}
            {locale === 'ca' && <F0 />}
            {locale === 'ca' && <GG />}
            {!SHOW_TS_BUNDLE_SITE && <F />}
            {US_SITE && <F1 />}
            <div className="section-special">
                {!SHOW_TS_BUNDLE_SITE && (
                    <>
                        <G />
                        <G1 />
                    </>
                )}
                {/* <D /> */}
                {US_SITE && <H />}
            </div>
            {US_SITE && <H2 />}
            <I />
            {locale !== 'au' && <M />}
            {!['sa'].includes(locale) && <N />}
            {locale === 'au' && <M />}
            <O />
            {/* <P /> */}
        </div>
    );
}
